// extracted by mini-css-extract-plugin
export var compactFilters = "_dx-4";
export var detailImage = "_dx-1";
export var dropdownContainer = "_dx-2";
export var imageContainer = "_dx-0";
export var selectedCard = "_dx-3";